import payment from '@/api/supplier/payment'
import moment from 'moment'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  stockin: [],
  dateRange: [moment().startOf('M').format('DD-MM-YYYY'), moment().endOf('M').format('DD-MM-YYYY')]
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_STOCK_IN_LIST(state, data){
    state.stockin = data
  },
  PUSH_STOCK_IN_LIST(state, valuePush){
    state.stockin.push(valuePush)
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return payment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return payment.store(data)
  },
  update(context, { id, data }) {
    return payment.update(id, data)
  },
  destroy(context, { id, data }){
    return payment.destroy(id, data)
  },
  toPdf(context, id){
    return payment.toPdf(id)
  },
  async getStockIn(context) {
    let response = await payment.stockin()
    context.commit('SET_STOCK_IN_LIST', response.data)
  },
  async getBankProfile(context) {
    return await payment.bankProfile()
  }
}